export enum GameWeek {
  Week1 = 'Week1',
  Week2 = 'Week2',
  Week3 = 'Week3',
  Week4 = 'Week4',
  Week5 = 'Week5',
  Week6 = 'Week6',
  Week7 = 'Week7',
  Week8 = 'Week8',
  Week9 = 'Week9',
  Week10 = 'Week10',
  Week11 = 'Week11',
  Week12 = 'Week12',
  Week13 = 'Week13',
  Week14 = 'Week14',
  Week15 = 'Week15',
  Week16 = 'Week16',
  Week17 = 'Week17',
  Week18 = 'Week18',
}

export enum Season {
  'Season2023' = '2023',
  'Season2024' = '2024',
  'Season2025' = '2025',
  'Season2026' = '2026',
}

export const AvailableSeasons = ['2023', '2024', '2025', '2026'];

/**
 * Placeholder TeamAbrvID used for empty team slots in UI components.
 * Represents a non-existent team when filling gaps in display grids.
 */
export const EMPTY_TEAM_ABRV_ID = '00-empty';
